import { mapState } from "vuex";
import {
  getRouteByRoles,
  hasPermission,
  hasRole,
  getHighestRole,
} from "@/utils/permission";

export default {
  computed: {
    ...mapState(["roles"]),

    // 用户最高权限角色
    userHighestRole() {
      return getHighestRole(this.roles);
    },

    // 用户对应的默认路由
    userDefaultRoute() {
      return getRouteByRoles(this.roles);
    },

    // 是否是教师
    isTeacher() {
      return hasRole(this.roles, "teacher");
    },

    // 是否是学生
    isStudent() {
      return hasRole(this.roles, "student");
    },

    // 是否是管理员
    isAdmin() {
      return hasRole(this.roles, "admin");
    },
  },

  methods: {
    /**
     * 检查是否有指定权限
     * @param {string} permission - 权限名称
     * @returns {boolean}
     */
    checkPermission(permission) {
      return hasPermission(this.roles, permission);
    },

    /**
     * 检查是否有指定角色
     * @param {string|Array} requiredRoles - 需要的角色
     * @returns {boolean}
     */
    checkRole(requiredRoles) {
      return hasRole(this.roles, requiredRoles);
    },

    /**
     * 根据角色跳转到对应页面
     */
    navigateByRole() {
      const route = getRouteByRoles(this.roles);
      this.$router.push(route);
    },

    /**
     * 带权限检查的路由跳转
     * @param {string} route - 目标路由
     * @param {string} permission - 需要的权限
     * @param {string} fallbackRoute - 无权限时的回退路由
     */
    navigateWithPermission(route, permission, fallbackRoute = "/") {
      if (this.checkPermission(permission)) {
        this.$router.push(route);
      } else {
        this.$message.warning("您没有访问该页面的权限");
        this.$router.push(fallbackRoute);
      }
    },
  },
};
